import { SMLRouteNames } from './SMLRoutes';

/** The pages that sign-in opens anyway. A link to them needs no `returnTo`. */
const START_PATHS = new Set(['', SMLRouteNames.home, SMLRouteNames.auth]);

/**
 * The `returnTo` value for a signed-out visit to a private page (an email link, an OAuth consent),
 * so that sign-in opens that page and not the artist Home. `pathname` is relative to `/app`, as
 * react-router gives it. Returns null for a start page.
 */
export function signInReturnTo(pathname: string, search: string): string | null {
  const path = pathname.replace(/^\/+/, '').replace(/\/+$/, '');
  if (START_PATHS.has(path) && search === '') {
    return null;
  }
  return `${path}${search}`;
}

/** The OAuth consent page: `/oauth/authorize` sends a signed-out person to sign in with it as `returnTo`. */
const OAUTH_CONSENT_PATH = 'oauth-consent';

/**
 * True when sign-in was opened by the OAuth flow: `returnTo` is the consent page with its query.
 * Only then does the sign-in page offer "Sign in with a password" (spec 2026-10-10 MCP apps §3.3).
 */
export function isOAuthConsentReturnTo(returnTo: string): boolean {
  return returnTo.split('?')[0] === OAUTH_CONSENT_PATH;
}
